var WishList = {
	init:function(){
		this.addToWishlist();
		this.removeFromWishlist();

		$(".must--logged .btn-close").on("click touchend", function(e){
			e.stopPropagation();
			e.preventDefault();
			if(e.type=='touchend'){
				$(this).off("click");
			}

			$(".must--logged").removeClass("visible");
		});

		$(".must--logged .shadow").on("click touchend", function(e){
			e.stopPropagation();
			e.preventDefault();
			if(e.type=='touchend'){
				$(this).off("click");
			}

			$(".must--logged").removeClass("visible");
		});

	},
	removeFromWishlist: function(){
		$('.remove--wishlist').on('click', function(ev){
			ev.preventDefault();
			var productId = $(this).data('product');
			data = 'action=akrolab_remove_from_wishlist&idProduct=' + productId;
			console.log("Test ajout wishlist ajax : " + productId);
			$.ajax({
				url: ajaxurl,
				type:'POST',
				data: data,
				success: function (results) {
					results = JSON.parse(results);
					if(results.success){
						$('.total--wishlist').html(results.result.totalQuantity);
						window.location.href = results.result.redirect;
					}else{
						$('.must--logged').addClass("visible");
					}
				}
			});
		});
	},
	addToWishlist: function(){
		$('.btn--like').on('click', function(ev){
			ev.preventDefault();
			var productId = $(this).data('product');
			console.log(productId);
			data = 'action=akrolab_add_to_wishlist&idProduct=' + productId;
			var heart = $(this);


			$.ajax({
				url: ajaxurl,
				type:'POST',
				data: data,
				success: function (results) {
					results = JSON.parse(results);

					if(results.success){
						$('.total--wishlist').html(results.result.totalQuantity);
						heart.addClass('active');
					}else{
						$('.must--logged').addClass("visible");
					}
				}
			});
		});
	}
}

$(window).load(function(){
	WishList.init();
})

